<h4>Deal Deatails</h4>

<div class="selet_block">
	<div>
    <div class="flex_row">
      <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="data.deal.name" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" [disabled]="true"/>
        <mat-error>
          Name is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal ID</mat-label>
        <input disabled [(ngModel)]="data.deal.id" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>
    </div>

    <div class="field-name mt-4">Vizibl Deal Type</div>
    <div class="label_container">
      <mat-chip-listbox [(ngModel)]="data.deal.vizibl_deal_type" aria-label="Fish selection"
      [disabled]="true" >
        <mat-chip-option  class="me-3" value="private_deal">
          Private</mat-chip-option>
        <mat-chip-option value="regular">Regular
        </mat-chip-option>
      </mat-chip-listbox>
    </div>

    <div class="flex_row mt-3">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal Type </mat-label>
        <mat-select required [(ngModel)]="data.deal.deal_type" placeholder="Choose One" [multiple]="false" disabled>
          <mat-option *ngFor="let type of dealOptions" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal Source</mat-label>
        <input disabled [(ngModel)]="data.deal.source" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Media Type </mat-label>
        <mat-select required [(ngModel)]="data.deal.media_type" placeholder="Choose One" [multiple]="false" disabled>
          <mat-option *ngFor="let type of mediaOptions" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal Price</mat-label>
        <input disabled [(ngModel)]="data.deal.price" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Price Type </mat-label>
        <mat-select required [(ngModel)]="data.deal.price_type" placeholder="Choose One" [multiple]="false" disabled>
          <mat-option *ngFor="let type of priceOptions" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal Status </mat-label>
        <mat-select required [(ngModel)]="data.deal.deal_status" placeholder="Choose One" [multiple]="false" disabled>
          <mat-option *ngFor="let type of dealStatusOptions" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Deal Admin State </mat-label>
        <mat-select required [(ngModel)]="data.deal.admin_state" placeholder="Choose One" [multiple]="false"
        [disabled]="true">
          <mat-option *ngFor="let type of dealAdminStatusOptions" [value]="type.value">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Start Date</mat-label>
        <input disabled [(ngModel)]="data.deal.start_date" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
        <mat-error>
          Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>End Date</mat-label>
        <input disabled [(ngModel)]="data.deal.end_date" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Imps by Device Type</mat-label>
        <input disabled [(ngModel)]="data.deal.imps_by_device_type" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>CTR</mat-label>
        <input  disabled [(ngModel)]="data.deal.click_through_rate" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Bid Count</mat-label>
        <input  disabled [(ngModel)]="data.deal.bid_count" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Bid Response</mat-label>
        <input  disabled [(ngModel)]="data.deal.bid_responses" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Conversion Count</mat-label>
        <input  disabled [(ngModel)]="data.deal.convs_count" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Measureable Imps</mat-label>
        <input  disabled [(ngModel)]="data.deal.measurable_imps" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>
    </div>

    <div class="flex_row">
      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Completion Count</mat-label>
        <input  disabled [(ngModel)]="data.deal.completion_count" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Total Imps</mat-label>
        <input disabled [(ngModel)]="data.deal.total_imps" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>

      <mat-form-field class="li_input_field me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>Avg CPM</mat-label>
        <input disabled [(ngModel)]="data.deal.average_cpm" [maxLength]="90" style="height: auto;" matInput
          required type="text" placeholder="Enter name" />
      </mat-form-field>
    </div>

    <div class="field-name mt-4">Top Seller Information</div>
    <div class="table-content mb-3">
      <table mat-table [dataSource]="sellerDataSource" #sellerTableSort='matSort'  matSort style="width: 100%">

        <ng-container matColumnDef="seller_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="table_header_name"> Seller Name</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name"> {{ row.seller_name}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="bid_request_volume_rate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="table_header_name"> Bid Request Volume Rate (%)</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row.bid_request_volume_rate * 100 | number:'1.2-2'}}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="sellerColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: sellerColumns"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="13">No data available</td>
        </tr>
      </table>
      <mat-paginator #sellerTablePaginator [pageSizeOptions]="[10, 15, 25, 100]"
        [length]="sellerCount">
      </mat-paginator>
    </div>

	</div>
	<div class="select_block_action">
		<button mat-button class="action_btn_no-border"
			(click)="closeModel()">Done</button>
	</div>
</div>
